jQuery(document).ready(function ($) {
  $('.category-filter a').click(function (e) {
    e.preventDefault();

    // Remove active class from all category links
    $('.category-filter a').removeClass('active');

    // Add active class to the clicked category link
    $(this).addClass('active');
    var category_id = $(this).data('category');
    $.ajax({
      type: 'POST',
      url: ajax_object.ajax_url,
      data: {
        action: 'filter_blog_posts',
        category_id: category_id
      },
      success: function success(response) {
        $('.blog-posts').html(response);
      }
    });
  });
});